$(function(){
    // 智能推荐视频
    $('.ProductItem_video_img').each(function () {
        $(this).click(function(){
          $('.video_poupop_cen').css('display','block');
        })
     })

    sessionStorage.removeItem('recommend_products_ids');
    sessionStorage.removeItem('recommend_card_id');
    sessionStorage.removeItem('recommend_products');
    window.intelligent_recommend( clientId , email);
    $('.recommend-product-home .back-top').click(function(){
        $('html, body').animate({ scrollTop: 0 }, 600); // 600 毫秒动画时间
        return false;
    })
})
// 智能推荐视频卡片视频播放
$(document).ready(function(){
    var video_cen=$('.video_poupop_cen_con video')[0];
    console.log('音量');
    // 监听 loadedmetadata 事件
    $('.video_poupop_cen_con video').on('loadedmetadata', function() {
        const duration = video_cen.duration;  // 获取视频总时长（秒）
    console.log('视频时长',duration);
        if(video_cen.duration/60>1){
        var all_min_num=Math.floor(video_cen.duration/60);
        if(all_min_num<10){
            $('.end_min').text('0'+ all_min_num);
        }else{
            $('.end_min').text(all_min_num);
        }
        if(Math.floor(video_cen.duration-all_min_num*60)<10){
            $('.end_second').text('0'+ Math.floor(video_cen.duration-all_min_num*60)); 
        }else{
            $('.end_second').text(Math.floor(video_cen.duration-all_min_num*60));
        }
        }else{
            $('.end_min').text('00');
        if(Math.floor(video_cen.duration)<10){
            $('.end_second').text('0'+Math.floor(video_cen.duration)); 
        }else{
            $('.end_second').text(Math.floor(video_cen.duration));
        }
            
        }
    });
    $(".video_poupop .muteButton").each(function () {
      $(this).click(function(){
        var video = $('.video_poupop_cen_con video')[0]; // 转换为原生DOM对象
        console.log('点击音量按钮',video.muted);
        video.muted = !video.muted; // 切换静音状态
        if($(this).find('.iconfont').hasClass('icon-Volume')){
          $(this).find('.iconfont').removeClass('icon-Volume').addClass('icon-Volume-Up');
        }else{
          $(this).find('.iconfont').removeClass('icon-Volume-Up').addClass('icon-Volume');
        }
      });
    })
    $('.video_poupop .video_poupop_close .icon-Close').click(function(){
       console.log('点击关闭');
      var video = $('.video_poupop_cen_con video')[0]; // 获取video DOM对象
      const $video = $('.video_poupop_cen_con video');
      $video.prop('muted', true); // 关闭时静音
      $('.video_poupop .muteButton .iconfont').addClass('.icon-Volume-Up').removeClass('icon-Volume');
      $('.video_poupop .muteButton').show();
      video.pause(); //暂停控制
      $(".video_poupop .playBtn").attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552');
            $('body').css({
              'overflow': '',
              'position': '',
              'top': '',
              'left': '',
              'right': '',
              'bottom': ''
            });
          var scrollTop = $('body').attr('data-overflow-top');
          $(window).scrollTop(scrollTop);
    })
    $(".video_poupop .playBtn").each(function () {
      $(this).click(function(){
        console.log('点击播放',$('.video_poupop_cen_con video')[0]);
        var video = $('.video_poupop_cen_con video')[0]; // 获取video DOM对象
        if (video.paused) {
          console.log('开始播放');
          $('.video_poupop .muteButton').hide();
           video.play(); // 播放视频
          $(this).attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552');
        }else{
          console.log('停止播放');
          $('.video_poupop .muteButton').show();
            video.pause(); //暂停控制
            $(this).attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552');
        }
        // 进度条
          var progressBar = $(this).siblings('.progressBarContainer').find('.progressBar');
          var handleProgress = function(){
            var percentage = (100 / video.duration) * video.currentTime;
            if((video.duration-video.currentTime)/60>1){
              var min_num=Math.floor((video.duration-video.currentTime)/60);
              if(min_num<10){
                $('.end_min').text('0'+ min_num);
              }else{
                $('.end_min').text(min_num);
              }
              if(Math.floor(video.duration-min_num*60-video.currentTime)<10){
                  $('.end_second').text('0'+ Math.floor(video.duration-min_num*60-video.currentTime)); 
              }else{
                  $('.end_second').text(Math.floor(video.duration-min_num*60-video.currentTime));
              }
            }else{
               $('.end_min').text('00');
              if(Math.floor(video.duration-video.currentTime)<10){
                  $('.end_second').text('0'+ Math.floor(video.duration-video.currentTime)); 
              }else{
                  $('.end_second').text(Math.floor(video.duration-video.currentTime));
              }
               
            }
            
            console.log('进度',Math.floor(video.duration-video.currentTime),min_num,video.currentTime);
            progressBar.css('width', percentage + '%');
          };
         
          video.addEventListener('timeupdate', handleProgress, false);
      });
    })
})
// 监听滚动事件
var scrollThreshold = 200; // 滚动的阈值，每滚动200像素调用一次函数
var jiazai_num=0;
// 滚动事件处理函数
var lastScrollTop = $('.off-discount-coupon-inner').offset().top-1000;
function scrollEventHandler() {
    if (!allowScrollHandler) {
        return;
    }
    // 获取当前滚动条的位置
    let scrollTop =  $(window).scrollTop();
    // 判断滚动的距离是否超过阈值，并且是向下滚动
        // 在这里编写原来的滚动事件处理逻辑
    if (scrollTop > lastScrollTop && (scrollTop - lastScrollTop) >= scrollThreshold) {
        jiazai_num+=1;
        // 调用需要执行的函数
        // 更新上次滚动的位置
        console.log('加载次数',jiazai_num);
        if(jiazai_num<8){
            lastScrollTop = $(window).scrollTop();
            window.intelligent_recommend( clientId , email);
        }

    }
}